import { render } from "./GeneralList.vue?vue&type=template&id=674e7891"
import script from "./GeneralList.vue?vue&type=script&lang=js"
export * from "./GeneralList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\刘晓辉\\代码\\Graphql\\前端\\calfsys\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__